import { InfoCards } from "../../_models";
import { DoughnutChartData } from "../data-visualization/doughnut-chart/doughnut-chart.component";
import { InlineTableData } from "../data-visualization/data-table/data-table.component";
import { ProductViewType } from "../orders/orders.data";

export enum SubscriptionInfo {
  CancelRequests = 0,
  Saved = 1,
  SavedRevenue = 2,
  Cancelled = 3,
  RetentionRate = 4,
}

export enum TrendClass {
  Positive = 'trend-positive',
  Negative = 'trend-negative',
}

/* Cards Data */
export const subscriptionTopCards: InfoCards = [
  {
    title: "Cancel Requests",
    value: "--",
    hint: "Total number of customers who requested to cancel their subscription.",
    percentage: null,
    is_negative: false,
    subtitle: "--",
  },
  {
    title: "Saved",
    value: "--",
    hint: "Total number of subscriptions that were successfully saved.",
    percentage: null,
    is_negative: false,
    subtitle: "--",
  },
  {
    title: "Saved Revenue",
    value: "--",
    hint: "Total revenue retained from saved subscriptions.",
    percentage: null,
    is_negative: false,
    subtitle: "Projected MRR protected",
  },
  {
    title: "Cancelled",
    value: "--",
    hint: "Total number of subscriptions that were successfully cancelled.",
    percentage: null,
    is_negative: false,
    subtitle: "--",
  },
  {
    title: "Retention Rate",
    value: "--",
    hint: "The percentage of cancel requests that were successfully retained.",
    percentage: null,
    is_negative: false,
    subtitle: "--",
  },
];

/* Retention Summary Doughnut */
export const subscriptionDoughnutData: DoughnutChartData = {
  data: [],
  noData: false,
  loading: true,
  total: "",
  labels: ["Saved", "Cancelled", "Abandoned", "Other"],
  backgroundColors: [
    {
      backgroundColor: ["#00D67E", "#FF8971", "#FFD666", "#CBD5E1"],
    },
  ],
};

export const subscriptionSummaryTableData: InlineTableData = [
  { name: "Saved", color: "#00D67E", value: "--", percentage: "--" },
  { name: "Cancelled", color: "#FF8971", value: "--", percentage: "--" },
  { name: "Abandoned", color: "#FFD666", value: "--", percentage: "--" },
  { name: "Other", color: "#CBD5E1", value: "--", percentage: "--" },
];

/* Top Cancellation Reasons (Grouped Horizontal Bar) */
export const subscriptionCancellationReasons = {
  data: [],
  loading: true,
  noData: false,
};

/* Performance by Offer Type */
export const subscriptionOfferTypeData = {
  data: [],
  loading: true,
  noData: false,
};

/* Performance by Product */
export const subscriptionProductData = {
  data: [],
  baseData: null as any[] | null,
  campaignData: null as any[] | null,
  loading: true,
  noData: false,
  type: ProductViewType.Base,
};

/* Performance by Billing Cycle (Grouped Horizontal Bar) */
export const subscriptionBillingCycleData = {
  data: [],
  loading: true,
  noData: false,
};

/* Performance by Frequency (Grouped Horizontal Bar) */
export const subscriptionFrequencyData = {
  data: [],
  loading: true,
  noData: false,
};

/* Performance by Campaign */
export const subscriptionCampaignData = {
  data: [],
  loading: true,
  noData: false,
};

/* Performance by Customer Stage */
export const subscriptionCustomerStageData = {
  data: [],
  loading: true,
  noData: false,
};

/* Canceled With Pending Order */
export const canceledWithPendingOrderData = {
  show: false,
  loading: true,
  quantity: '--' as string,
  subscriptionValueLost: '--' as string,
  cancellationRate: '--' as string,
  cycle1Quantity: '--' as string,
  cycle1Value: '--' as string,
  cycle2Quantity: '--' as string,
  cycle2Value: '--' as string,
  avgValue: '--' as string,
};

export const subscriptionHints = {
  topCards: {
    cancelRequests: 'Total number of customers who requested to cancel their subscription.',
    cancelled: 'Total number of subscriptions that were successfully cancelled.',
    abandoned: 'Customers who started the cancellation flow but did not complete it.',
    retentionRate: 'The percentage of cancel requests that were successfully retained.',
  },
  retentionSummary: 'An overview of subscription cancellation session outcomes.',
  cancellationReasons: 'The most common reasons customers request to cancel their subscriptions.',
  offerType: 'Performance of retention offers presented to customers during cancellation.',
  product: 'Retention performance broken down by product.',
  billingCycle:
    'This table highlights the subscription cycle at which customers most frequently initiate cancellations. It also provides a breakdown of those requests, showing how many were successfully retained versus how many resulted in cancellations.',
  frequency: 'This table shows how retention performance varies by subscription frequency. It highlights how many cancellation requests were initiated for each frequency, along with a breakdown of how many were successfully retained versus how many resulted in cancellations',
  campaign: 'Retention performance grouped by marketing campaign.',
  customerStage: "Retention performance based on the customer's subscription stage.",
  canceledWithPendingOrder: 'Subscriptions that were cancelled while an order was still pending fulfillment, broken down by billing cycle.',
};
